import React, { useState, useEffect } from "react";
import s from "./CuponesModal.module.css";

import Swal from "sweetalert2";

import Modal from "@mui/material/Modal"
import Grid from "@mui/material/Grid"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import TableContainer from "@mui/material/TableContainer"
import Table from "@mui/material/Table"
import TableHead from "@mui/material/TableHead"
import TableCell from "@mui/material/TableCell"
import TableBody from "@mui/material/TableBody"
import TableRow from "@mui/material/TableRow"
import CircularProgress from "@mui/material/CircularProgress"
import Tooltip from "@mui/material/Tooltip"
import Pagination from "@mui/material/Pagination"
import CloseIcon from "@mui/icons-material/Close";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import couponsService from "../../../../../../../api/delivery/couponsService";
import deliveryServices from "../../../../../../../api/delivery/DeliveryService";

const CuponesModal = ({
  edit,
  open,
  setOpen,
  type,
  selectedGame,
  setFormulario,
  formulario,
  passingType,
  setRaffles,
}) => {
  const { activeOrganization } = useSelector((state) => state.gamma);
  const couponService = couponsService;
  const [loading, setLoading] = useState(false);

  const [selected, setSelected] = useState({});

  const { textColor } = useSelector((state) => state.local);
  const { t } = useTranslation();

  const [items, setItems] = useState([]);

  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [submitLoader, setSubmitLoader] = useState(false);

  const callItems = () => {
    if (formulario.supplierId) {
      deliveryServices
        .getProductsBySupplierId(formulario.supplierId, page)
        .then((res) => {
          setItems(res.content);
          setTotalPages(res.totalPages);
        })
        .then(() => setLoading(false))
        .catch((e) => console.log(e));
    } else {
      couponService
        .getStockByGame(page, 10, "ASC", "raffleId", selectedGame.id)
        .then((res) => {
          setItems(res.content);
          setTotalPages(res.totalPages);
        })
        .then(() => setLoading(false))
        .catch((e) => console.log(e));
    }
  };

  const handlePaginate = (e, v) => {
    setPage(v);
  };

  useEffect(() => {
    setTo(selected.nroCouponTo);
    setFrom(selected.nroCouponFrom);
    setLoading(true);
    callItems();
  }, [page]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSelectPackage = (item) => {
    setFrom(item.nroCouponFrom);
    setTo(item.nroCouponTo);
    setSelected(item);
    if(item.game.instant===false){
    setFormulario((prev) => {
      return {
        ...prev,
        settlementDate: item.raffle.raffleDate,
      };
    });
    }
    
  };

  const handleSubmit = () => {
    setSubmitLoader(true);
    if (formulario.detailList.find((i) => i.raffleId === selected.raffle.id)) {
      Swal.fire(t("existProduct"), t("selectOther"), "error");
      setSelected({});
      setOpen(false);
      setSubmitLoader(false);
    } else {
      let payload = {
        amount: to - from + 1,
        nroCouponFrom: from,
        nroCouponTo: to,
        gameId: selected.game.id,
        raffleId: selected.raffle.id,
      };
      setFormulario((prev) => {
        return {
          ...prev,
          detailList: [payload],
        };
      });
      setRaffles((prev) => [...prev, { raffleReadDTO: selected?.raffle }]);
      setSubmitLoader(false);
      setSelected({});
      setOpen(false);
    }
  };

  const cellStyles = {
    fontFamily: "Roboto, sans-serif",
    fontSize: "0.9rem",
    fontWeight: "400",
    borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
    cursor: "pointer",
  };

  const [errorCouponsAmount, setErrorCouponsAmount] = useState({ error: false, message: "" })

  useEffect(() => {
    setTimeout(() => {
      const amount = to - from + 1;
      const isInstant = selected?.game?.instant;
      const isValidAmount = amount % selected?.raffle?.couponsAmountPerBundle !== 0 ? false : true;

      if (!isValidAmount && isInstant) {
        setErrorCouponsAmount({
          error: true,
          message: `Cantidad de cupones debe ser múltiplo de la cantidad de cupones por paquete(${selected.raffle.couponsAmountPerBundle}).`
        })
      } else {
        setErrorCouponsAmount((prev) => ({ ...prev, error: false }))
      }
    }, [1000])

  }, [from, selected, to])

  function validRange() {
    const isValid = (
      to > selected.nroCouponTo ||
      to < selected.nroCouponFrom ||
      from > selected.nroCouponTo ||
      from < selected.nroCouponFrom ||
      to < from ||
      errorCouponsAmount.error
    )

    if (isValid) return true;
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <Grid container>
        <Grid
          container
          item
          xs={12}
          md={9}
          lg={5}
          className={s.boxModal}
          sx={{ bgcolor: "#EEEEEE" }}
        >
          <Grid
            container
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "center", mb: 3 }}
          >
            <Grid item xs={12} className={s.exit}>
              <div className={s.titleModal}>
                <p>{`${t("select")} ${t("coupons")}`}</p>
                <span>{selectedGame.name}</span>
              </div>
              <CloseIcon
                onClick={handleClose}
                className={s.exitIcon}
                sx={{ color: "primary.dark" }}
              />
            </Grid>

            <Grid container item xs={11} className={s.results}>
              {loading ? (
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress size={"4rem"} />
                </Grid>
              ) : (
                <>
                  <TableContainer className={s.tableContainer}>
                    <Table>
                      <TableHead sx={{ backgroundColor: "primary.main" }}>
                        <TableCell
                          sx={{
                            color: textColor,
                            fontSize: ".8rem",
                            fontWeight: 500,
                            fontFamily: "Roboto, sans-Serif",
                          }}
                        >
                          {t("game")}
                        </TableCell>
                        <TableCell
                          sx={{
                            color: textColor,
                            fontSize: ".8rem",
                            fontWeight: 500,
                            fontFamily: "Roboto, sans-Serif",
                          }}
                        >
                          {type === "INSTANTANEO"
                            ? t("serie")
                            : t("drawNumber")}
                        </TableCell>
                        <TableCell
                          sx={{
                            color: textColor,
                            fontSize: ".8rem",
                            fontWeight: 500,
                            fontFamily: "Roboto, sans-Serif",
                          }}
                        >
                          {t("quantity")}
                        </TableCell>
                        <TableCell
                          sx={{
                            color: textColor,
                            fontSize: ".8rem",
                            fontWeight: 500,
                            fontFamily: "Roboto, sans-Serif",
                          }}
                        >{`${t("coupons")} ${t("from")}`}</TableCell>
                        <TableCell
                          sx={{
                            color: textColor,
                            fontSize: ".8rem",
                            fontWeight: 500,
                            fontFamily: "Roboto, sans-Serif",
                          }}
                        >{`${t("coupons")} ${t("to")}`}</TableCell>
                      </TableHead>
                      <TableBody>
                        {items?.length ? (
                          items?.map((paquete, i) => {
                            return (
                              <React.Fragment key={i}>
                                <Tooltip title={t("select")} placement="left">
                                  <TableRow
                                    onClick={() => {
                                      handleSelectPackage(paquete);
                                    }}
                                    sx={{
                                      backgroundColor:
                                        JSON.stringify(selected) ===
                                          JSON.stringify(paquete)
                                          ? "primary.light"
                                          : null,
                                    }}
                                  >
                                    <TableCell
                                      sx={{
                                        ...cellStyles,
                                        backgroundColor:
                                          i % 2 === 0
                                            ? "#dbdbdb76"
                                            : "#dbdbdd12",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {paquete.game.name}
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        ...cellStyles,
                                        backgroundColor:
                                          i % 2 === 0
                                            ? "#dbdbdb76"
                                            : "#dbdbdd12",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {paquete.raffle.serie ||
                                        paquete.raffle.number ||
                                        "-"}
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        ...cellStyles,
                                        backgroundColor:
                                          i % 2 === 0
                                            ? "#dbdbdb76"
                                            : "#dbdbdd12",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {paquete.nroCouponTo -
                                        paquete.nroCouponFrom +
                                        1}
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        ...cellStyles,
                                        backgroundColor:
                                          i % 2 === 0
                                            ? "#dbdbdb76"
                                            : "#dbdbdd12",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {paquete.nroCouponFrom}
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        ...cellStyles,
                                        backgroundColor:
                                          i % 2 === 0
                                            ? "#dbdbdb76"
                                            : "#dbdbdd12",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {paquete.nroCouponTo}
                                    </TableCell>
                                  </TableRow>
                                </Tooltip>
                              </React.Fragment>
                            );
                          })
                        ) : (
                          <TableRow>
                            <p style={{ marginLeft: "10px" }}>{t("noStock")}</p>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  <Grid
                    item
                    xs={12}
                    sx={{ display: "flex", justifyContent: "center", my: 5 }}
                    className={s.pagination}
                  >
                    <Pagination
                      count={totalPages}
                      page={page}
                      onChange={handlePaginate}
                      color="primary"
                      disabled={loading}
                    />
                  </Grid>

                  {selected?.id ? (
                    <Grid
                      item
                      container
                      xs={12}
                      className={s.selectors}
                      sx={{ my: 5 }}
                    >
                      <span>{`${t("select")} ${t("quantity").toLocaleLowerCase()}`}</span>
                      <Grid
                        item
                        container
                        xs={10}
                        sx={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          mt: 3,
                        }}
                      >
                        <Grid item xs={5}>
                          <TextField
                            label={t("from")}
                            sx={{ width: "100%" }}
                            value={from}
                            onChange={(e) => {
                              if (!isNaN(e.target.value)) {
                                setFrom(Number(e.target.value));
                              }
                            }}
                          />
                        </Grid>
                        <Grid item xs={5}>
                          <TextField
                            label={t("to")}
                            sx={{ width: "100%", ml: 1 }}
                            value={to}
                            onChange={(e) => {
                              if (!isNaN(e.target.value)) {
                                setTo(Number(e.target.value));
                              }
                            }}
                          />
                        </Grid>
                        {validRange() ? (
                          <Grid
                            item
                            xs={12}
                            ml={"5px"}
                            className={s.info}
                          >
                            {
                              errorCouponsAmount.error ?
                                <p
                                  style={{ fontSize: "16px", color: "#a64452" }}
                                >
                                  ⚠ {errorCouponsAmount.message}
                                </p> :
                                <p
                                  style={{ fontSize: "16px", color: "#a64452" }}
                                >
                                  {`⚠ ${t("invalidRanges")}`}
                                </p>
                            }
                          </Grid>
                        ) : (
                          <Grid item xs={12} ml={"5px"} className={s.info}>
                            <p
                              style={{ fontSize: "16px", color: "#408140" }}
                            >{`✓ ${t("quantity")}: ${to - from + 1}`}</p>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  ) : null}

                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      mt: 1,
                      mb: 1,
                    }}
                  >
                    {submitLoader ? (
                      <CircularProgress size="1.8rem" />
                    ) : (
                      <Button
                        variant="contained"
                        disabled={
                          Object.keys(selected).length === 0 ||
                          to > selected.nroCouponTo ||
                          to < selected.nroCouponFrom ||
                          from > selected.nroCouponTo ||
                          from < selected.nroCouponFrom ||
                          to < from ||
                          errorCouponsAmount.error
                        }
                        onClick={() => handleSubmit()}
                      >
                        {t("add")}
                      </Button>
                    )}
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Modal >
  );
};

export default CuponesModal;
